<template>
  <transition appear name="fade">
    <div class="modal is-active">
      <div class="modal-background" @click="CloseModal"></div>
      <div class="modal-content">
        <div class="close" @click="CloseModal">
          <i class="fal fa-times"></i>
        </div>
        <div class="modal-box">
          <div class="field">
            <label class="label"><label class="error_text">*</label> Select Month</label>
            <div class="control">
              <date-picker v-model="date" type="month" valueType="format" placeholder="YYYY/MM"></date-picker>
            </div>
          </div>
          <div class="close" @click="CloseModal">
            <i class="fal fa-times"></i>
          </div>
          <!-- <img v-if="isLoading" src="../../assets//lg.ring-loading-gif.gif" class="img" /> -->
          <div class="button-group">
            <button @click="download(id)" :class="['button primary', { 'is-loading': isLoading }]">
              Download
            </button>
          </div>
          <br />
          <h5 v-if="msg" style="color:red">{{ msg }}</h5>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import axios from "axios";
export default {
  components: { DatePicker },
  data: () => ({
    date: "",
    msg: "",
    isLoading: false,
  }),

  methods: {
    CloseModal() {
      this.$emit("CloseModal");
    },
    async download(id) {
      try {
        if (!this.date) return (this.msg = "Please select month!");
        this.msg = "";
        this.isLoading = true;
        const dates = moment(this.date).format("YYYY-MM");
        axios.defaults.headers["Authorization"] = this.$store.getters.Token;
        const res = await axios.get(
          `${process.env.VUE_APP_HTTPS_ADMIN}/api/download-emp-monthly-report?date=${dates}&empId=${id}`
        );
        if (res.data === "No Information!") {
          this.msg = res.data;
          this.isLoading = false;
          return;
        }
        const response = await fetch(res.data);
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = res.data.split("/").pop();
        document.body.appendChild(link);
        link.click();
        this.isLoading = false;
      } catch (err) {
        console.log("error");
        throw new Error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.error_text {
  color: red;
}

.modal-content {
  position: relative;

  .close {
    cursor: pointer;
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    right: 0;
    z-index: 999;
    border-radius: 0 0 0 10px;
    background-color: rgba(var(--grey-color), 0.3);
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 30px;
      color: var(--grey-color);
    }
  }

  .modal-box {
    background-color: #fff;
    padding: 60px;
  }

  .button-group {
    margin-top: 20px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.mobile-format {
  display: flex;
  align-items: center;
  position: relative;

  span {
    position: absolute;
    margin-right: 10px;
    color: var(--primary-color);
    font-weight: 700;
    z-index: 999;
    left: 10px;
  }

  input.input {
    padding-left: 70px;
  }
}

.img {
  width: 50px;
  height: 50px;
}
</style>
